import { each, get, isEmpty, map, sortBy } from 'lodash-es';

import * as api from './../../api/api.service';
import { IAptAttachment } from '../../core/layout/fileUpload/aptFileAttachments.service';

export class CompareRfiController {
  static bindings = {
    navName: '@',
    account: '<'
  };

  titleAndSubtitle = {
    title: 'Compare Sellers',
    subtitle: ''
  };

  account: any;

  rfpId: number;

  rfpInfo;

  featureList;

  rfiQuestions: any[] = [];

  rfiResponses: any[] = [];

  categoryUnspscs: any[] = [];

  sellerUnspscParticipationResponses: any[] = [];

  categoryAddendaResponses: any[] = [];

  categoryAddendaTerms: any[] = [];

  sellerList: any[] = [];

  hideAddendaTab = true;

  activeTab = 'RFIResponses';

  categoryId: number;

  attachments: IAptAttachment[];

  constructor(
    public $scope,
    private api: api.IApiService,
    public legacyCompareRFIApi,
    $route,
    public LoadingIndicator,
    LayoutService,
    $q
  ) {
    'ngInject';

    let rfpSellerIds: number[]; // this is only necessary for the legacy calls

    this.rfpId = $route.current.params.rfpId;

    LoadingIndicator.show();

    this.api.rfps.getAttachments(this.rfpId).then((attachments) => {
      this.attachments = attachments;
    });

    var featureListRequest = this.api.features.getFeatures();

    featureListRequest.then((featureList) => {
      this.featureList = featureList;

      LayoutService.subNavApi.isSubNavEnabled = true;

      this.api.rfps.getRfp(this.rfpId).then((data) => {
        this.rfpInfo = data;
        this.categoryId = this.rfpInfo.category.id;

        this.hideAddendaTab = this.rfpInfo.category.type === 'Custom';

        this.titleAndSubtitle.subtitle = `for ${this.rfpInfo.category.name}`;

        LayoutService.subNavApi.categoryType = this.rfpInfo.category.type;

        // data for RFI Responses tab
        var promises: any[] = [];
        this.sellerList = this.rfpInfo.sellers || [];

        rfpSellerIds = map(this.sellerList, 'id');

        each(this.sellerList, (seller) => {
          // Get questionnare data for each seller in the RFP
          // this sucks but we have to hit the API for every seller included in the RFP
          promises.push(
            this.legacyCompareRFIApi.getQuestionnaire(
              this.categoryId,
              seller.id
            )
          );
        });

        $q.all(promises).then((responses) => {
          each(responses, (response: any) => {
            // the question array in each response is exactly the same so store it the first time around
            if (isEmpty(this.rfiQuestions)) {
              this.rfiQuestions = get(response, 'questionnaire.question');
            }

            this.rfiResponses.push({
              sellerId: response.orgId,
              answers: response.answers
            });
          });
        });

        // this request gives us the list of unspscs for the RFP category and the unspcs the sellers participate in
        this.legacyCompareRFIApi
          .getSellerRFIResponses(this.categoryId, rfpSellerIds)
          .then((data) => {
            // keep categoryUnspscs and sellerUnspscParticipationResponses sorted the same so the correct checkbox is selected
            this.categoryUnspscs = sortBy(
              data.masterList.categoryUnspscs,
              'unspscsId'
            );
            this.sellerUnspscParticipationResponses = sortBy(
              data.sellerUnspscsList,
              'unspscsId'
            );
          });

        // data for Category Addenda tab
        this.legacyCompareRFIApi
          .getSellerCAComparisons(this.categoryId, rfpSellerIds)
          .then((data) => {
            if (!isEmpty(data.sellerCATerm) && data.sellerCATerm[0]) {
              // the title for the CA terms are in each sellers set of CA term responses,
              // so, from the sellerCATerm array, just pull the titles from the first element
              this.categoryAddendaTerms = map(
                data.sellerCATerm[0].caTerm,
                (caTerm: any) => {
                  return {
                    order: caTerm.displayOrder,
                    title: caTerm.title,
                    caId: data.sellerCATerm[0].caId
                  };
                }
              );

              this.categoryAddendaResponses = map(
                data.sellerCATerm,
                (sellerCA: any) => {
                  return {
                    caId: sellerCA.caId,
                    sellerId: sellerCA.sellerId,
                    responses: map(sellerCA.caTerm, (term: any) => {
                      return {
                        text: term.termText,
                        order: term.displayOrder
                      };
                    })
                  };
                }
              );
            }

            LoadingIndicator.hide();
          });
      });
    });
  }
}

export const CompareRfiComponent = {
  bindings: CompareRfiController.bindings,
  controller: CompareRfiController,
  template: require('./compareRfi.html')
};
